import React from 'react';
import PropTypes from 'prop-types';
import LoaderSVG from '../shared/loaderSVG';

const UserResultsSummary = props => (
  <div
    className="user-results-summary"
    style={{ marginTop: props.userSearchResultsHeight }}
  >
    {props.userSearchStatus === 'searching' && (
      <span className="flex-span">
        <LoaderSVG /> {props.searchingMessage}
      </span>
    )}
    {props.userSearchStatus === '' && (
      <span id="autocomplete-results-count">
        {props.resultsCount} {props.resultsText}
      </span>
    )}
    {props.userSearchStatus === '' && <span>{props.customizeSearchText}</span>}
  </div>
);

UserResultsSummary.propTypes = {
  resultsText: PropTypes.string.isRequired,
  customizeSearchText: PropTypes.string.isRequired,
  userSearchResultsHeight: PropTypes.string.isRequired,
  resultsCount: PropTypes.number.isRequired,
  userSearchStatus: PropTypes.string.isRequired,
  searchingMessage: PropTypes.string.isRequired,
};

export default UserResultsSummary;
